/* ! Modified from John Doherty's MIT-licensed https://github.com/john-doherty/swiped-events */ (()=>{
    "use strict";
    const THRESHOLD = 100;
    const TIMEOUT = 500;
    let downX = null;
    let downY = null;
    let diffX = 0;
    let diffY = 0;
    let timeDown = null;
    let startElement = null;
    if (typeof window.CustomEvent !== "function") {
        // @ts-ignore
        window.CustomEvent = (event, params)=>{
            params = params || {
                bubbles: false,
                cancelable: false,
                detail: undefined
            };
            const e = document.createEvent("CustomEvent");
            e.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
            return e;
        };
        // @ts-ignore
        window.CustomEvent.prototype = window.Event.prototype;
    }
    function handleTouchEnd(e) {
        if (startElement !== e.target) return;
        const timeDiff = Date.now() - timeDown;
        let eventType = "";
        if (Math.abs(diffX) > Math.abs(diffY)) {
            if (Math.abs(diffX) > THRESHOLD && timeDiff < TIMEOUT) {
                if (diffX > 0) eventType = "swiped-left";
                else eventType = "swiped-right";
            }
        } else if (Math.abs(diffY) > THRESHOLD && timeDiff < TIMEOUT) {
            if (diffY > 0) eventType = "swiped-up";
            else eventType = "swiped-down";
        }
        if (eventType) startElement.dispatchEvent(new CustomEvent(eventType, {
            bubbles: true,
            cancelable: true
        }));
        downX = null;
        downY = null;
        timeDown = null;
    }
    function handleTouchStart(e) {
        const board = document.getElementById("board");
        if (board?.contains(e.target)) return;
        startElement = e.target;
        timeDown = Date.now();
        downX = e.touches[0].clientX;
        downY = e.touches[0].clientY;
        diffX = 0;
        diffY = 0;
    }
    function handleTouchMove(e) {
        if (!downX || !downY) return;
        diffX = downX - e.touches[0].clientX;
        diffY = downY - e.touches[0].clientY;
    }
    document.addEventListener("touchstart", handleTouchStart, false);
    document.addEventListener("touchmove", handleTouchMove, false);
    document.addEventListener("touchend", handleTouchEnd, false);
})();


/* ! Modified from John Doherty's MIT-licensed https://github.com/john-doherty/long-press-event */ (()=>{
    "use strict";
    const TOUCH = "ontouchstart" in window || navigator.maxTouchPoints > 0;
    const mouseDown = TOUCH ? "touchstart" : "mousedown";
    const mouseUp = TOUCH ? "touchend" : "mouseup";
    const mouseMove = TOUCH ? "touchmove" : "mousemove";
    const MAX_DIFF = 10;
    const TIMEOUT = 500;
    let timer = null;
    let startX = 0;
    let startY = 0;
    if (typeof window.CustomEvent !== "function") {
        // @ts-ignore
        window.CustomEvent = (event, params)=>{
            params = params || {
                bubbles: false,
                cancelable: false,
                detail: undefined
            };
            const e = document.createEvent("CustomEvent");
            e.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
            return e;
        };
        // @ts-ignore
        window.CustomEvent.prototype = window.Event.prototype;
    }
    function isTouch(e) {
        return "touches" in e;
    }
    function fireLongPressEvent(element, e) {
        clearLongPressTimer();
        const clientX = isTouch(e) ? e.touches[0].clientX : e.clientX;
        const clientY = isTouch(e) ? e.touches[0].clientY : e.clientY;
        const longPress = element.dispatchEvent(new CustomEvent("long-press", {
            bubbles: true,
            cancelable: true,
            detail: {
                clientX: clientX,
                clientY: clientY
            }
        }));
        if (longPress) document.addEventListener(mouseUp, (e)=>{
            e.stopImmediatePropagation();
            e.preventDefault();
            e.stopPropagation();
            element.dispatchEvent(new CustomEvent("long-press-up", {
                bubbles: true,
                cancelable: true,
                detail: {
                    clientX: clientX,
                    clientY: clientY
                }
            }));
        }, {
            once: true,
            capture: true
        });
    }
    function startLongPressTimer(e) {
        clearLongPressTimer();
        const start = new Date().getTime();
        const loop = ()=>{
            const current = new Date().getTime();
            const delta = current - start;
            const timeout = e.target?.id === "title" ? TIMEOUT * 10 : TIMEOUT;
            if (delta >= timeout) fireLongPressEvent(e.target, e);
            else timer.value = window.requestAnimationFrame(loop);
        };
        timer = {
            value: window.requestAnimationFrame(loop)
        };
    }
    function clearLongPressTimer() {
        if (timer) window.cancelAnimationFrame(timer.value);
        timer = null;
    }
    function mouseDownHandler(e) {
        const board = document.getElementById("board");
        if (board?.contains(e.target)) return;
        startX = isTouch(e) ? e.touches[0].clientX : e.clientX;
        startY = isTouch(e) ? e.touches[0].clientY : e.clientY;
        startLongPressTimer(e);
    }
    function mouseMoveHandler(e) {
        const diffX = Math.abs(startX - (isTouch(e) ? e.touches[0].clientX : e.clientX));
        const diffY = Math.abs(startY - (isTouch(e) ? e.touches[0].clientY : e.clientY));
        if (diffX >= MAX_DIFF || diffY >= MAX_DIFF) clearLongPressTimer();
    }
    document.addEventListener(mouseUp, clearLongPressTimer, true);
    document.addEventListener(mouseMove, mouseMoveHandler, true);
    document.addEventListener("wheel", clearLongPressTimer, true);
    document.addEventListener("scroll", clearLongPressTimer, true);
    document.addEventListener(mouseDown, mouseDownHandler, true);
})();


function $55dcb6b52fc85e3d$export$f36d6a7a5c09a23e(word, dict) {
    const val = dict[word];
    if (!val) return "";
    const re = /[{<](.*?)?=.*?[>}]/g;
    let def = dict[word].defn;
    if (!def) return "";
    const match = re.exec(def);
    if (match) {
        const m = dict[match[1].toUpperCase()];
        if (!m?.defn) def = match[1];
        else def = `${match[1]} (${m.defn})`;
    }
    return def.replace(/\{(.*?)=.*?\}/g, "$1").replace(/<(.*?)=.*?>/g, "$1").replace(/\s*?\[.*?\]\s*?/g, "");
}
function $55dcb6b52fc85e3d$export$1ea939691cdc45b8(word, dict, type) {
    const val = dict[word];
    return val && (!val.dict || val.dict.includes(type.charAt(0)));
}
function $55dcb6b52fc85e3d$export$aaaeab0fac9a3ccb(words) {
    const ordered = [];
    const anadromes = new Set();
    for (const w of words){
        const r = w.split("").reverse().join("");
        if (r !== w && words.includes(r)) {
            const key = `${[
                w,
                r
            ].sort().join(" ")}`;
            if (!anadromes.has(key)) {
                anadromes.add(key);
                ordered.push(`(${w}`, `${r})`);
            }
        } else ordered.push(w);
    }
    return ordered;
}


class $2f4d5440d89e6de9$export$3cdec2bba15e3523 {
    constructor(percentiles, dict){
        this.dict = dict;
        this.percentiles = percentiles;
        this.mixed = {};
        for(const word in dict){
            const anagram = $2f4d5440d89e6de9$export$3cdec2bba15e3523.toAnagram(word);
            this.mixed[anagram] = this.mixed[anagram] || [];
            this.mixed[anagram].push(word);
        }
    }
    anagrams(word, type, min) {
        const a = $2f4d5440d89e6de9$export$3cdec2bba15e3523.toAnagram(word);
        const group = this.mixed[a];
        const result = {
            words: []
        };
        if (!group) return result;
        for (const w of group){
            if (min && w.length < min) continue;
            if ((0, $55dcb6b52fc85e3d$export$1ea939691cdc45b8)(w, this.dict, type)) {
                result.words.push(w);
                const v = this.dict[w];
                for (const d of [
                    "n",
                    "o",
                    "b"
                ])if (v[d]) result[d] = (result[d] || 0) + v[d];
            }
        }
        return result;
    }
    stats(word, dice = "New", type = "NWL") {
        const val = this.dict[word];
        const a = this.anagrams(word, type);
        if (!(0, $55dcb6b52fc85e3d$export$1ea939691cdc45b8)(word, this.dict, type) || !a.words.length) return {
            grade: " "
        };
        const pf = val.freq === undefined ? -1 : this.percentiles.freqs.findIndex((v)=>v <= val.freq);
        const f = pf === -1 ? " " : $2f4d5440d89e6de9$var$gradeFreq(pf);
        const s = this.percentiles[dice][type];
        const d = dice.charAt(0).toLowerCase();
        const vw = val[d] || 0;
        const pw = s.words.findIndex((v)=>v <= vw);
        const rw = $2f4d5440d89e6de9$var$rank(pw);
        const va = a[d] || 0;
        const pa = s.anagrams.findIndex((v)=>v <= va);
        const ra = $2f4d5440d89e6de9$var$rank(pa);
        const g = [
            " ",
            "A",
            "B",
            "C",
            "D"
        ][Math.ceil((rw + ra) / 2)];
        const pct = (v)=>Math.round(100 * v / s.total * 1000) / 1000;
        const result = {
            grade: g < f ? f : g
        };
        if (pf > -1) result.freq = pf;
        if (pw > -1) result.word = {
            p: pw,
            v: pct(val.freq)
        };
        if (pa > -1) result.anagram = {
            p: pa,
            v: pct(va)
        };
        return result;
    }
    history(games, dice, type) {
        const d = dice.charAt(0).toLowerCase();
        const reverse = (w)=>w.split("").reverse().join("");
        const ratio = {};
        const anadromes = {};
        const anagrams = {};
        const all = {};
        const either = {};
        const found = {};
        let n = games.length;
        for (const [possible, played] of games){
            const as = {};
            for(const w in possible){
                all[w] = (all[w] || 0) + 1;
                const a = $2f4d5440d89e6de9$export$3cdec2bba15e3523.toAnagram(w);
                as[a] = as[a] || [];
                as[a].push(w);
                if (played.has(w)) {
                    found[w] = (found[w] || 0) + 1;
                    const r = reverse(w);
                    if (r !== w && possible[r]) {
                        const k = [
                            w,
                            r
                        ].sort()[0];
                        if (!played.has(r)) {
                            either[k] = (either[k] || 0) + 1;
                            // FIXME: why does this not remove NOD/DON in Big dice?
                            anadromes[k] = (anadromes[w] || 0) + 1 / n * this.dict[k][d];
                        } else if (w === k) either[k] = (either[k] || 0) + 1;
                    }
                } else ratio[w] = (ratio[w] || 0) + 1 / n * this.dict[w][d];
            }
            for(const a in as){
                const group = as[a];
                if (group.length <= 1) continue;
                const f = group.filter((w)=>played.has(w)).length / group.length;
                if (!f) continue;
                const w = group.reduce((acc, w)=>acc + this.dict[w][d], 0) / group.length;
                anagrams[a] = (anagrams[a] || 0) + 1 / n * w * (1 - f);
            }
            n--;
        }
        const K = Math.log(games.length);
        for(const w in all){
            ratio[w] += K * this.dict[w][d] * Math.pow(1 - (found[w] || 0) / all[w], 2);
            if (anadromes[w]) {
                const r = reverse(w);
                const [a, b] = (found[r] || 0) > (found[w] || 0) ? [
                    w,
                    r
                ] : [
                    r,
                    w
                ];
                anadromes[w] += K * this.dict[w][d] * 2 * Math.pow(1 - (found[a] || 0) / (all[b] || 1), 2);
            }
            const a = $2f4d5440d89e6de9$export$3cdec2bba15e3523.toAnagram(w);
            if (anagrams[a] && all[w]) anagrams[w] += K * this.dict[w][d] * Math.pow(1 - (found[w] || 0) / all[w], 2);
        }
        const sorted = (obj, limit)=>Object.entries(obj).sort((a, b)=>b[1] - a[1]).slice(0, limit);
        return {
            words: sorted(ratio, 100).map((e)=>({
                    w: e[0],
                    found: found[e[0]] || 0,
                    all: all[e[0]] || 0
                })),
            anadromes: sorted(anadromes, 50).map((e)=>{
                const k = e[0];
                const r = reverse(k);
                const [n, d] = (found[r] || 0) > (found[k] || 0) ? [
                    k,
                    r
                ] : [
                    r,
                    k
                ];
                return {
                    n: n,
                    fn: found[n] || 0,
                    d: d,
                    fd: found[d] || 0,
                    e: either[k] || 0
                };
            }),
            anagrams: sorted(anagrams, 50).map((e)=>{
                const group = [];
                // FIXME: should pass in min length and 3 letter words should have B scores
                for (const r of (0, $55dcb6b52fc85e3d$export$aaaeab0fac9a3ccb)(this.anagrams(e[0], type).words)){
                    const w = r.replace(/[^A-Z]/, "");
                    group.push({
                        raw: r,
                        found: found[w] || 0,
                        all: all[w] || 0
                    });
                }
                return group;
            })
        };
    }
    static toAnagram(word) {
        return word.split("").sort().join("");
    }
}
function $2f4d5440d89e6de9$var$gradeFreq(p) {
    if (p >= 99) return " ";
    if (p >= 20) return "A";
    if (p >= 10) return "B";
    if (p >= 5) return "C";
    return "D";
}
function $2f4d5440d89e6de9$var$rank(p) {
    if (p >= 75) return 0;
    if (p >= 50) return 1;
    if (p >= 25) return 2;
    if (p >= 10) return 3;
    return 4;
}


class $565bb8264fce4bd8$export$390f32400eaf98c9 {
    static async setup(dbName = "keyval", storeNames = [
        "keyval"
    ]) {
        return new Promise((resolve, reject)=>{
            const openreq = indexedDB.open(dbName, 1);
            openreq.onerror = ()=>reject(openreq.error);
            openreq.onsuccess = ()=>resolve(openreq.result);
            openreq.onupgradeneeded = ()=>{
                for (const storeName of storeNames)openreq.result.createObjectStore(storeName);
            };
        });
    }
    constructor(dbName = "keyval", storeName = "keyval"){
        this.dbName = dbName;
        this.storeName = storeName;
        this.db = new Promise((resolve, reject)=>{
            const openreq = indexedDB.open(dbName, 1);
            openreq.onerror = ()=>reject(openreq.error);
            openreq.onsuccess = ()=>resolve(openreq.result);
            // First time setup: create an empty object store
            openreq.onupgradeneeded = ()=>{
                openreq.result.createObjectStore(storeName);
            };
        });
    }
    get(key) {
        let req;
        return this.withIDBStore("readonly", (store)=>{
            req = store.get(key);
        }).then(()=>req.result);
    }
    set(key, value) {
        return this.withIDBStore("readwrite", (store)=>{
            store.put(value, key);
        });
    }
    withIDBStore(type, callback) {
        return this.db.then((db)=>new Promise((resolve, reject)=>{
                const transaction = db.transaction(this.storeName, type);
                transaction.oncomplete = ()=>resolve();
                transaction.onabort = transaction.onerror = ()=>reject(transaction.error);
                callback(transaction.objectStore(this.storeName));
            }));
    }
}



class $69e3cfcc1b264755$export$a92776769f460054 {
    constructor(n = 4 /* https://xkcd.com/221/ */ ){
        // Hash: https://burtleburtle.net/bob/hash/integer.html
        n = n ^ 61 ^ n >>> 16;
        n = n + (n << 3);
        n = n ^ n >>> 4;
        n = Math.imul(n, 0x27d4eb2d);
        n = n ^ n >>> 15;
        this.seed = n >>> 0;
    }
    // Mulberry32: https://gist.github.com/tommyettinger/46a874533244883189143505d203312c
    next(min, max) {
        if (min) min = Math.floor(min);
        if (max) max = Math.floor(max);
        let z = this.seed += 1831565813;
        z = Math.imul(z ^ z >>> 15, z | 1);
        z = z ^ z + Math.imul(z ^ z >>> 7, z | 61);
        z = (z ^ z >>> 14) >>> 0;
        const n = z / 2 ** 32;
        if (min === undefined) return n;
        if (!max) return Math.floor(n * min);
        return Math.floor(n * (max - min)) + min;
    }
    shuffle(arr) {
        for(let i = arr.length - 1; i > 0; i--){
            const j = Math.floor(this.next() * (i + 1));
            [arr[i], arr[j]] = [
                arr[j],
                arr[i]
            ];
        }
        return arr;
    }
    sample(arr, remove = false) {
        if (arr.length === 0) throw new RangeError("Cannot sample an empty array");
        const index = this.next(arr.length);
        const val = arr[index];
        if (remove) {
            arr[index] = arr[arr.length - 1];
            arr.pop();
        }
        if (val === undefined && !Object.prototype.hasOwnProperty.call(arr, index)) throw new RangeError("Cannot sample a sparse array");
        return val;
    }
}


const $96aac1339b3e6cb8$var$PERIOD = 3;
const $96aac1339b3e6cb8$var$DAY = 86400000;
function $96aac1339b3e6cb8$var$defaultCompare(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
}
class $96aac1339b3e6cb8$var$Queue {
    constructor(data = [], compare = $96aac1339b3e6cb8$var$defaultCompare){
        this.data = data;
        this.length = this.data.length;
        this.compare = compare;
        if (this.length > 0) for(let i = (this.length >> 1) - 1; i >= 0; i--)this.down(i);
    }
    push(item) {
        this.data.push(item);
        this.length++;
        this.up(this.length - 1);
    }
    pop() {
        if (this.length === 0) return undefined;
        const top = this.data[0];
        const bottom = this.data.pop();
        this.length--;
        if (this.length > 0) {
            this.data[0] = bottom;
            this.down(0);
        }
        return top;
    }
    peek() {
        return this.data[0];
    }
    up(pos) {
        const item = this.data[pos];
        while(pos > 0){
            const parent = pos - 1 >> 1;
            const current = this.data[parent];
            if (this.compare(item, current) >= 0) break;
            this.data[pos] = current;
            pos = parent;
        }
        this.data[pos] = item;
    }
    down(pos) {
        const half = this.length >> 1;
        const item = this.data[pos];
        while(pos < half){
            let left = (pos << 1) + 1;
            let best = this.data[left];
            const right = left + 1;
            if (right < this.length && this.compare(this.data[right], best) < 0) {
                left = right;
                best = this.data[right];
            }
            if (this.compare(best, item) >= 0) break;
            this.data[pos] = best;
            pos = left;
        }
        this.data[pos] = item;
    }
}
class $96aac1339b3e6cb8$export$c612839cda33ff7e {
    static async create(stats, dice, type, store, min) {
        const d = dice.toLowerCase()[0];
        // NOTE: learned is shared across dice...
        const learned = new $96aac1339b3e6cb8$var$Queue([], (a, b)=>a.d - b.d);
        const queued = new Set();
        // TODO: store short separately and iterate over depending on min length
        const stored = await store.get("data");
        if (stored) {
            learned.data = stored;
            learned.length = stored.length;
            for (const s of stored)queued.add(s.k);
        }
        const raw = [];
        for(const k in stats.mixed)if (!queued.has(k)) {
            const w = stats.anagrams(k, type, min)[d] || 0;
            if (w) raw.push({
                k: k,
                w: w
            });
        }
        raw.sort((a, b)=>a.w - b.w);
        const unlearned = raw.map((e)=>e.k);
        return new $96aac1339b3e6cb8$export$c612839cda33ff7e(unlearned, learned, d, type, store, stats);
    }
    constructor(unlearned, learned, d, type, store, stats){
        this.unlearned = unlearned;
        this.learned = learned;
        this.size = learned.length;
        this.d = d;
        this.type = type;
        this.store = store;
        this.stats = stats;
    }
    overdue() {
        const now = +new Date();
        const popped = [];
        let overdue = this.size === this.learned.length ? 0 : 1;
        for(let next = this.learned.pop(); next; next = this.learned.pop()){
            popped.push(next);
            if (next.d > now) break;
            overdue++;
        }
        for (const p of popped)this.learned.push(p);
        return overdue;
    }
    next() {
        const now = +new Date();
        const backfill = ()=>{
            if (!this.unlearned.length) return undefined;
            return {
                k: this.unlearned.pop(),
                e: 2.5,
                c: 0,
                n: 0,
                d: 0,
                p: 0
            };
        };
        // TODO: what about if settings change and group no longer valid (eg. min length)?
        let next = this.learned.pop();
        if (next) {
            if (next.d > now) {
                const fill = backfill();
                if (fill) {
                    this.learned.push(next);
                    next = fill;
                }
            }
        } else next = backfill();
        if (!next) throw new RangeError();
        let key = next.k;
        const anagrams = this.stats.anagrams(key, this.type);
        const group = anagrams.words;
        const restore = ()=>{
            this.learned.push(next);
            this.size = this.learned.length;
        };
        const update = (q)=>{
            next = $96aac1339b3e6cb8$var$adjust(next, q, now);
            restore();
            return this.store.set("data", this.learned.data);
        };
        const random = new (0, $69e3cfcc1b264755$export$a92776769f460054)(next.n);
        // try to find a permutation which isn't in the group
        for(let i = 0; i < 10; i++){
            key = random.shuffle(key.split("")).join("");
            if (!group.includes(key)) break;
        }
        return {
            label: key,
            group: (0, $55dcb6b52fc85e3d$export$aaaeab0fac9a3ccb)(group),
            update: update,
            restore: restore
        };
    }
}
function $96aac1339b3e6cb8$var$adjust(v, q, now) {
    // Standard update from SM2: https://www.supermemo.com/en/archives1990-2015/english/ol/sm2
    let mod = -0.8 + 0.28 * q - 0.02 * q * q;
    // During the initial learning phase (n < 5), only apply a fraction of the modifier if negative
    // https://apps.ankiweb.net/docs/manual.html#what-spaced-repetition-algorithm-does-anki-use
    if (mod < 0) mod *= Math.min(Math.pow(2, v.n + 1) * 2.5, 100) / 100;
    // SM2 uses a minimum easiness of 1.3
    const min = 1.3;
    if (q >= 3) {
        // http://www.blueraja.com/blog/477/a-better-spaced-repetition-learning-algorithm-sm2
        const bonus = v.d ? Math.min(2, (v.d - v.p) / $96aac1339b3e6cb8$var$DAY / (v.c ? $96aac1339b3e6cb8$var$PERIOD : 1)) : 1;
        v.c++;
        v.e = Math.max(min, v.e + mod * bonus);
        v.d = now + $96aac1339b3e6cb8$var$DAY * $96aac1339b3e6cb8$var$PERIOD * Math.pow(v.e, v.c - 1) * bonus;
    } else {
        v.c = 0;
        v.e = Math.max(min, v.e + mod);
        v.d = now + $96aac1339b3e6cb8$var$DAY;
    }
    v.n++;
    v.p = now;
    return v;
}





const $e46db5192eb49d53$var$NEW_DICE = [
    "AAEEGN",
    "ELRTTY",
    "AOOTTW",
    "ABBJOO",
    "EHRTVW",
    "CIMOTU",
    "DISTTY",
    "EIOSST",
    "DELRVY",
    "ACHOPS",
    "HIMNQU",
    "EEINSU",
    "EEGHNW",
    "AFFKPS",
    "HLNNRZ",
    "DEILRX"
];
const $e46db5192eb49d53$var$OLD_DICE = [
    "AACIOT",
    "AHMORS",
    "EGKLUY",
    "ABILTY",
    "ACDEMP",
    "EGINTV",
    "GILRUW",
    "ELPSTU",
    "DENOSW",
    "ACELRS",
    "ABJMOQ",
    "EEFHIY",
    "EHINPS",
    "DKNOTU",
    "ADENVZ",
    "BIFORX"
];
const $e46db5192eb49d53$var$BIG_DICE = [
    "AAAFRS",
    "AAEEEE",
    "AAFIRS",
    "ADENNN",
    "AEEEEM",
    "AEEGMU",
    "AEGMNN",
    "AFIRSY",
    "BJKQXZ",
    "CCNSTW",
    "CEIILT",
    "CEILPT",
    "CEIPST",
    "DDLNOR",
    "DHHLOR",
    "DHHNOT",
    "DHLNOR",
    "EIIITT",
    "EMOTTT",
    "ENSSSU",
    "FIPRSY",
    "GORRVW",
    "HIPRRY",
    "NOOTUW",
    "OOOTTU"
];
const $e46db5192eb49d53$export$4405dec33e6bc9e5 = [
    "S",
    "ER",
    "ED",
    "ING"
];
class $e46db5192eb49d53$export$985739bfa5723e08 {
    constructor(trie, dict, stats, random, settings = {
        dice: "New",
        dict: "NWL"
    }){
        this.trie = trie;
        this.dict = dict;
        this.stats = stats;
        this.dice = settings.dice === "Big" ? $e46db5192eb49d53$var$BIG_DICE : settings.dice === "Old" ? $e46db5192eb49d53$var$OLD_DICE : $e46db5192eb49d53$var$NEW_DICE;
        this.size = Math.sqrt(this.dice.length);
        settings.min = settings.min || this.size - 1;
        this.settings = settings;
        this.random = random;
        this.seed = this.random.seed;
        this.board = [];
        for (const die of this.dice){
            const c = this.random.sample(die.split(""));
            this.board.push(c === "Q" ? "Qu" : c);
        }
        this.random.shuffle(this.board);
        this.possible = this.solve();
        this.id = $e46db5192eb49d53$export$985739bfa5723e08.encodeID(this.settings, this.seed);
        this.played = {};
        this.overtime = new Set();
        this.score = {
            regular: 0,
            overtime: 0
        };
        this.start = +new Date();
        this.expired = null; // set to timestamp!
    }
    play(word) {
        if (!this.played[word] && word.length >= this.settings.min) {
            if (this.possible[word]) {
                this.played[word] = +new Date();
                const score = $e46db5192eb49d53$export$985739bfa5723e08.score(word);
                if (this.expired) this.overtime.add(word);
                const bucket = this.expired ? "overtime" : "regular";
                this.score[bucket] += score;
                return score;
            } else {
                this.played[word] = -new Date();
                if (this.expired) this.overtime.add(word);
            }
        }
        return 0;
    }
    toJSON() {
        return {
            seed: this.id,
            start: this.start,
            expired: this.expired,
            words: this.played,
            goal: {
                S: this.totals.s,
                A: this.totals.a,
                B: this.totals.b,
                C: this.totals.c,
                D: this.totals.d
            }
        };
    }
    static encodeID(s, seed) {
        return `${s.dice.charAt(0)}${s.min}${s.dict.charAt(0)}${seed}`;
    }
    static decodeID(id) {
        const d = id.charAt(0);
        const dice = d === "N" ? "New" : d === "O" ? "Old" : d === "B" ? "Big" : undefined;
        let min = Number(id.charAt(1));
        if (isNaN(min) || min < 3 || min > 5) min = undefined;
        const t = id.charAt(2);
        const dict = t === "N" ? "NWL" : t === "E" ? "ENABLE" : t === "C" ? "CSW" : undefined;
        const num = id.slice(3);
        let seed = num.length ? Number(num) : NaN;
        if (String(seed) !== num) seed = NaN;
        return [
            {
                dice: dice,
                min: min,
                dict: dict
            },
            seed
        ];
    }
    static fromJSON(json, trie, dict, stats) {
        const [settings, seed] = $e46db5192eb49d53$export$985739bfa5723e08.decodeID(json.seed);
        const random = new (0, $69e3cfcc1b264755$export$a92776769f460054)();
        random.seed = seed;
        const game = new $e46db5192eb49d53$export$985739bfa5723e08(trie, dict, stats, random, settings);
        // @ts-ignore readonly
        game.start = json.start;
        // @ts-ignore readonly
        game.expired = json.expired;
        // @ts-ignore readonly
        game.played = json.words;
        const score = {
            regular: 0,
            overtime: 0
        };
        for(const w in game.played){
            if (game.played[w] < 0) continue;
            const s = $e46db5192eb49d53$export$985739bfa5723e08.score(w);
            if (!game.expired || game.played[w] <= game.expired) score.regular += s;
            else score.overtime += s;
        }
        // @ts-ignore readonly
        game.score = score;
        return game;
    }
    get totals() {
        if (this.totals_) return this.totals_;
        const anagrams = {};
        const grades = {};
        for(const word in this.possible){
            const anagram = (0, $2f4d5440d89e6de9$export$3cdec2bba15e3523).toAnagram(word);
            anagrams[anagram] = anagrams[anagram] || [];
            anagrams[anagram].push(word);
            const g = this.stats.stats(word, this.settings.dice, this.settings.dict).grade;
            grades[g] = (grades[g] || 0) + $e46db5192eb49d53$export$985739bfa5723e08.score(word);
        }
        const d = grades.D || 0;
        const c = d + (grades.C || 0);
        const b = c + (grades.B || 0);
        const a = b + (grades.A || 0);
        const s = a + (grades[" "] || 0);
        return this.totals_ = {
            s: s,
            a: a,
            b: b,
            c: c,
            d: d,
            anagrams: anagrams
        };
    }
    progress() {
        let total = 0;
        let invalid = 0;
        let valid = 0;
        const suffixes = {};
        const subwords = new Set();
        const anagrams = {};
        for(const word in this.played){
            total++;
            if (this.played[word] < 0) {
                invalid++;
                continue;
            }
            valid++;
            for (const suffix of $e46db5192eb49d53$export$4405dec33e6bc9e5){
                let suffixed;
                if ([
                    "ER",
                    "ED"
                ].includes(suffix) && word.endsWith("E")) suffixed = `${word}${suffix.charAt(1)}`;
                else if (suffix === "S" && (word.endsWith("S") || word.endsWith("X"))) suffixed = `${word}ES`;
                else suffixed = `${word}${suffix}`;
                if (this.possible[suffixed] && !this.played[suffixed]) suffixes[suffixed] = word;
            }
            const anagram = (0, $2f4d5440d89e6de9$export$3cdec2bba15e3523).toAnagram(word);
            anagrams[anagram] = anagrams[anagram] || [];
            anagrams[anagram].push(word);
            for (const sub of $e46db5192eb49d53$var$subs(word, this.settings.min))if (this.possible[sub] && !this.played[sub]) subwords.add(sub);
        }
        let missing = [];
        for(const anagram in anagrams)missing = missing.concat(this.totals.anagrams[anagram].filter((w)=>!anagrams[anagram].includes(w)));
        const words = new Set([
            ...Object.keys(suffixes),
            ...subwords,
            ...missing
        ]);
        const score = this.score.regular + this.score.overtime + Array.from(words).reduce((sum, w)=>$e46db5192eb49d53$export$985739bfa5723e08.score(w) + sum, 0);
        return {
            invalid: invalid,
            valid: valid,
            total: total,
            score: score,
            suffixes: suffixes,
            subwords: subwords.size,
            anagrams: missing.length,
            missing: words
        };
    }
    state() {
        const progress = this.progress();
        const gr = (w)=>this.stats.stats(w, this.settings.dice, this.settings.dict).grade;
        // missing > grade > length > anagrams > alphabetical
        const fn = (a, b)=>{
            const ma = progress.missing.has(a);
            const mb = progress.missing.has(b);
            if (ma && !mb) return -1;
            if (mb && !ma) return 1;
            const ga = gr(a);
            const gb = gr(b);
            if (ga > gb) return -1;
            if (gb > ga) return 1;
            if (a.length > b.length) return 1;
            if (b.length > a.length) return -1;
            return (0, $2f4d5440d89e6de9$export$3cdec2bba15e3523).toAnagram(a).localeCompare((0, $2f4d5440d89e6de9$export$3cdec2bba15e3523).toAnagram(b));
        };
        const augment = (w)=>({
                word: w,
                grade: gr(w),
                defn: (0, $55dcb6b52fc85e3d$export$f36d6a7a5c09a23e)(w, this.dict)
            });
        return {
            played: Array.from(Object.entries(this.played)).sort((a, b)=>Math.abs(a[1]) - Math.abs(b[1])).map((e)=>{
                const w = e[0];
                const v = augment(w);
                if (e[1] < 0) v.invalid = true;
                if (this.overtime.has(w)) v.overtime = true;
                return v;
            }),
            remaining: Object.keys(this.possible).filter((w)=>!this.played[w]).sort(fn).map((w)=>{
                const v = augment(w);
                if (progress.missing.has(w)) v.missing = true;
                if (progress.suffixes[w]) v.root = progress.suffixes[w];
                return v;
            }),
            progress: progress,
            totals: this.totals
        };
    }
    solve() {
        const words = {};
        const queue = [];
        for(let y = 0; y < this.size; y++)for(let x = 0; x < this.size; x++){
            let c = this.board[this.size * y + x];
            const ord = c.charCodeAt(0);
            let node = this.trie.children[ord - 65];
            if (c === "Qu" && node !== undefined) {
                c = "QU";
                node = node.children[20]; // ('U' = 85) - 65
            }
            if (node !== undefined) queue.push([
                x,
                y,
                c,
                node,
                [
                    [
                        x,
                        y
                    ]
                ]
            ]);
        }
        while(queue.length !== 0){
            const [x, y, s, node, h] = queue.pop();
            // eslint-disable-next-line max-len
            for (const [dx, dy] of [
                [
                    1,
                    0
                ],
                [
                    1,
                    -1
                ],
                [
                    0,
                    -1
                ],
                [
                    -1,
                    -1
                ],
                [
                    -1,
                    0
                ],
                [
                    -1,
                    1
                ],
                [
                    0,
                    1
                ],
                [
                    1,
                    1
                ]
            ]){
                const [x2, y2] = [
                    x + dx,
                    y + dy
                ];
                if (h.find((e)=>e[0] === x2 && e[1] === y2) !== undefined) continue;
                if (x2 >= 0 && x2 < this.size && y2 >= 0 && y2 < this.size) {
                    const hist = h.slice();
                    hist.push([
                        x2,
                        y2
                    ]);
                    let c = this.board[this.size * y2 + x2];
                    let node2 = node.children[c.charCodeAt(0) - 65];
                    if (c === "Qu" && node2 !== undefined) {
                        c = "QU";
                        node2 = node2.children[20]; // ('U' = 85) - 65
                    }
                    if (node2 !== undefined) {
                        const s2 = s + c;
                        const isWord = typeof node2.isWord === "boolean" ? node2.isWord : node2.isWord.includes(this.settings.dict.charAt(0));
                        if (isWord && s2.length >= this.settings.min) words[s2] = hist;
                        queue.push([
                            x2,
                            y2,
                            s2,
                            node2,
                            hist
                        ]);
                    }
                }
            }
        }
        return words;
    }
    static score(word) {
        if (word.length < 3) return 0;
        if (word.length <= 4) return 1;
        if (word.length === 5) return 2;
        if (word.length === 6) return 3;
        if (word.length === 7) return 5;
        /* if (word.length >= 8) */ return 11;
    }
}
function $e46db5192eb49d53$var$subs(word, min) {
    const words = new Set();
    for(let b = 0; b < word.length; b++)for(let e = 1; e <= word.length - b; e++){
        const s = word.substr(b, e);
        if (s.length >= min) words.add(s);
    }
    return words;
}




class $f58af0fc7d096920$export$73571c50d0f2507e {
    constructor(parent, value){
        this.parent = parent;
        this.children = new Array(26);
        this.isWord = false;
        if (parent !== null) parent.children[value.charCodeAt(0) - 65] = this;
    }
    static create(dict) {
        const root = new $f58af0fc7d096920$export$73571c50d0f2507e(null, "");
        for(const word in dict){
            let current = root;
            for (const letter of word){
                const ord = letter.charCodeAt(0);
                let next = current.children[ord - 65];
                if (next === undefined) next = new $f58af0fc7d096920$export$73571c50d0f2507e(current, letter);
                current = next;
            }
            current.isWord = dict[word].dict || true;
        }
        return root;
    }
}


const $c1afce2e0b574aed$var$STORE = new (0, $565bb8264fce4bd8$export$390f32400eaf98c9)("db", "store");
const $c1afce2e0b574aed$var$DEFAULTS = {
    dice: "New",
    min: 3,
    dict: "NWL",
    grade: "D",
    shortcuts: "None",
    display: "Show",
    theme: "System"
};
const $c1afce2e0b574aed$var$fetchJSON = (url)=>fetch(url, {
        mode: "no-cors"
    }).then((j)=>j.json());
const $c1afce2e0b574aed$export$90b4d2ff6acb88af = {
    SETTINGS: JSON.parse(localStorage.getItem("settings")) || $c1afce2e0b574aed$var$DEFAULTS,
    STORE: $c1afce2e0b574aed$var$STORE,
    LIMIT: 500,
    MAX_SEED: 1e12,
    DICT: undefined,
    STATS: undefined,
    HISTORY: undefined,
    TRIE: undefined,
    GAMES: undefined,
    PLAYED: undefined,
    SEED: 0,
    LOADED: {
        DICT: $c1afce2e0b574aed$var$fetchJSON("data/dict.json").then((d)=>{
            $c1afce2e0b574aed$export$90b4d2ff6acb88af.DICT = d;
        }),
        TRIE: async ()=>{
            if ($c1afce2e0b574aed$export$90b4d2ff6acb88af.TRIE) return;
            await $c1afce2e0b574aed$export$90b4d2ff6acb88af.LOADED.DICT;
            $c1afce2e0b574aed$export$90b4d2ff6acb88af.TRIE = (0, $f58af0fc7d096920$export$73571c50d0f2507e).create($c1afce2e0b574aed$export$90b4d2ff6acb88af.DICT);
        },
        STATS: async ()=>{
            if ($c1afce2e0b574aed$export$90b4d2ff6acb88af.STATS) return;
            let stats;
            await Promise.all([
                $c1afce2e0b574aed$export$90b4d2ff6acb88af.LOADED.DICT,
                $c1afce2e0b574aed$var$fetchJSON("data/stats.json").then((s)=>{
                    stats = s;
                })
            ]);
            $c1afce2e0b574aed$export$90b4d2ff6acb88af.STATS = new (0, $2f4d5440d89e6de9$export$3cdec2bba15e3523)(stats, $c1afce2e0b574aed$export$90b4d2ff6acb88af.DICT);
        },
        HISTORY: $c1afce2e0b574aed$var$STORE.get("history").then((h)=>{
            $c1afce2e0b574aed$export$90b4d2ff6acb88af.HISTORY = h || [];
        }),
        TRAINING: (0, $565bb8264fce4bd8$export$390f32400eaf98c9).setup("training", [
            "NWL",
            "ENABLE",
            "CSW"
        ]),
        GAMES: async ()=>{
            if ($c1afce2e0b574aed$export$90b4d2ff6acb88af.GAMES) return;
            await Promise.all([
                $c1afce2e0b574aed$export$90b4d2ff6acb88af.LOADED.HISTORY,
                $c1afce2e0b574aed$export$90b4d2ff6acb88af.LOADED.TRIE(),
                $c1afce2e0b574aed$export$90b4d2ff6acb88af.LOADED.DICT,
                $c1afce2e0b574aed$export$90b4d2ff6acb88af.LOADED.STATS()
            ]);
            $c1afce2e0b574aed$export$90b4d2ff6acb88af.GAMES = [];
            for(let i = $c1afce2e0b574aed$export$90b4d2ff6acb88af.HISTORY.length - 1; i >= 0 && $c1afce2e0b574aed$export$90b4d2ff6acb88af.GAMES.length < $c1afce2e0b574aed$export$90b4d2ff6acb88af.LIMIT; i--){
                const game = (0, $e46db5192eb49d53$export$985739bfa5723e08).fromJSON($c1afce2e0b574aed$export$90b4d2ff6acb88af.HISTORY[i], $c1afce2e0b574aed$export$90b4d2ff6acb88af.TRIE, $c1afce2e0b574aed$export$90b4d2ff6acb88af.DICT, $c1afce2e0b574aed$export$90b4d2ff6acb88af.STATS);
                const played = new Set();
                for(const w in game.played)if (game.played[w] > 0) played.add(w);
                $c1afce2e0b574aed$export$90b4d2ff6acb88af.GAMES.push([
                    game.possible,
                    played
                ]);
            }
        },
        PLAYED: async ()=>{
            if ($c1afce2e0b574aed$export$90b4d2ff6acb88af.PLAYED) return;
            await $c1afce2e0b574aed$export$90b4d2ff6acb88af.LOADED.HISTORY;
            $c1afce2e0b574aed$export$90b4d2ff6acb88af.PLAYED = new Set();
            for (const h of $c1afce2e0b574aed$export$90b4d2ff6acb88af.HISTORY)$c1afce2e0b574aed$export$90b4d2ff6acb88af.PLAYED.add(h.seed);
        }
    }
};








class $c97362ee32723b49$export$c57e9b2d8b9e4de {
    constructor(display, duration, elapsed = 0, expireFn = null, updateFn = null){
        this.duration = duration;
        this.display = display;
        this.elapsed = elapsed;
        this.interval = null;
        this.expireFn = expireFn;
        this.updateFn = updateFn;
        this.render();
    }
    toJSON() {
        return {
            duration: this.duration,
            elapsed: this.elapsed
        };
    }
    start() {
        if (this.interval) return;
        this.begin = new Date().getTime();
        this.last = this.begin;
        this.interval = setInterval(()=>this.update(), 100);
    }
    stop() {
        if (this.interval) {
            clearInterval(this.interval);
            this.interval = null;
            this.begin = new Date().getTime();
            this.elapsed += this.begin - this.last;
            this.last = this.begin;
        }
    }
    toggle() {
        if (this.interval) this.stop();
        else this.start();
    }
    expired() {
        return this.elapsed >= this.duration;
    }
    update() {
        const now = new Date().getTime();
        this.elapsed += now - this.last;
        this.last = now;
        const before = this.display.textContent;
        this.render();
        if (before !== this.display.textContent && this.updateFn) this.updateFn();
    }
    render() {
        let distance;
        if (this.expired()) {
            this.display.classList.add("expired");
            distance = this.elapsed - this.duration;
            if (this.expireFn) {
                this.expireFn();
                this.expireFn = null;
            }
        } else {
            this.display.classList.remove("expired");
            distance = this.duration - this.elapsed;
        }
        const minutes = Math.floor(distance % 3600000 / 60000);
        const seconds = `${Math.floor(distance % 60000 / 1000)}`.padStart(2, "0");
        const time = `${minutes}:${seconds}`;
        // Safari doesn't fire click events on the display while we're updating ¯\_(ツ)_/¯
        if (time !== this.display.textContent) this.display.textContent = time;
    }
}




const $5733c26233441270$var$DURATION = 180000;
const $5733c26233441270$var$VALID = (s)=>s.split("").every((c)=>c >= "A" && c <= "Z" || c >= "a" && c <= "z");
class $5733c26233441270$export$373e09b633948dc {
    constructor(json){
        this.last = json ? json.last : "";
        this.kept = json ? json.kept : false;
        this.game = json ? json.game : undefined;
        this.paused = json ? json.paused : false;
        const { display: display, timer: timer } = this.createTimer(json?.timer);
        this.timer = timer;
        this.timerDisplay = display;
        document.addEventListener("visibilitychange", ()=>{
            if (document.hidden) this.timer.stop();
            else if (!this.paused) this.timer.start();
        });
    }
    toJSON() {
        return {
            last: this.last,
            kept: this.kept,
            paused: this.paused,
            timer: this.timer.toJSON(),
            game: this.game && ("random" in this.game ? this.game.toJSON() : this.game)
        };
    }
    async init(data = {}) {
        await Promise.all([
            (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).LOADED.DICT,
            (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).LOADED.TRIE(),
            (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).LOADED.STATS(),
            (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).LOADED.HISTORY,
            (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).LOADED.PLAYED()
        ]);
        if (!this.game || data.new) {
            let seed = (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SEED;
            if (this.game) {
                this.timer.stop();
                if (!("random" in this.game)) this.game = (0, $e46db5192eb49d53$export$985739bfa5723e08).fromJSON(this.game, (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).TRIE, (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).DICT, (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).STATS);
                if (this.game.seed === seed) seed = this.game.random.seed % (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).MAX_SEED;
                (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).PLAYED.add(this.game.id);
                if (Object.values(this.game.played).filter((t)=>t > 0).length) {
                    this.updateGames();
                    (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).HISTORY.push(this.game.toJSON());
                    await (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).STORE.set("history", (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).HISTORY);
                }
            }
            let game;
            const random = new (0, $69e3cfcc1b264755$export$a92776769f460054)();
            while(!game || !Object.keys(game.possible).length){
                random.seed = seed;
                const id = (0, $e46db5192eb49d53$export$985739bfa5723e08).encodeID((0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SETTINGS, random.seed);
                if ((0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).PLAYED.has(id) && !data.allowDupes) {
                    seed = (seed + 1) % (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).MAX_SEED;
                    continue;
                }
                game = new (0, $e46db5192eb49d53$export$985739bfa5723e08)((0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).TRIE, (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).DICT, (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).STATS, random, (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SETTINGS);
            }
            this.game = game;
            (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SEED = seed;
            const { display: display, timer: timer } = this.createTimer();
            this.timer = timer;
            this.timerDisplay = display;
            this.last = "";
            this.kept = false;
            this.paused = false;
        } else if (!("random" in this.game)) this.game = (0, $e46db5192eb49d53$export$985739bfa5723e08).fromJSON(this.game, (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).TRIE, (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).DICT, (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).STATS);
        const hash = `#${this.game.id}`;
        if (document.location.hash !== hash) window.history.replaceState(null, "", hash);
        if (!this.full) this.full = (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).createElementWithId("div", "full");
        if (!this.score) {
            this.score = (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).createElementWithId("div", "score");
            this.displayScore();
        }
    }
    async attach(data = {}) {
        await this.init(data);
        this.container = (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).createElementWithId("div", "game");
        const touch = "ontouchstart" in window || navigator.maxTouchPoints > 0;
        const back = (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).createBackButton(()=>(0, $635ad17e88fce26c$export$4b08aed5f1ec6952).toggleView("Menu"));
        back.addEventListener("long-press", (e)=>{
            if (touch) e.preventDefault();
            return this.refresh({
                new: true
            });
        });
        const score = (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).createElementWithId("div", "score-wrapper");
        score.appendChild(this.score);
        score.addEventListener("mouseup", ()=>(0, $635ad17e88fce26c$export$4b08aed5f1ec6952).toggleView("Score"));
        score.addEventListener("long-press", ()=>this.onLongPress());
        score.addEventListener("long-press-up", ()=>this.onLongPressUp());
        this.container.appendChild((0, $635ad17e88fce26c$export$4b08aed5f1ec6952).createTopbar(back, this.timerDisplay, score));
        this.container.appendChild(this.full);
        this.container.appendChild(this.renderBoard());
        this.displayScore();
        this.word = (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).createElementWithId("input", "word");
        this.word.setAttribute("type", "text");
        this.word.classList.add("word");
        this.word.addEventListener("beforeinput", (e)=>this.onBeforeInput(e));
        if (touch) this.word.setAttribute("disabled", "disabled");
        this.container.appendChild(this.word);
        this.defn = (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).createElementWithId("div", "defn");
        this.defn.classList.add("definition");
        this.container.appendChild(this.defn);
        if (!this.paused) this.timer.start();
        return this.container;
    }
    renderBoard() {
        const game = this.game;
        const content = (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).createElementWithId("div", "board-wrapper");
        const table = (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).createElementWithId("table", "board");
        if (game.size > 4) table.classList.add("big");
        this.tds = new Set();
        const random = new (0, $69e3cfcc1b264755$export$a92776769f460054)(game.seed);
        for(let row = 0; row < game.size; row++){
            const tr = document.createElement("tr");
            for(let col = 0; col < game.size; col++){
                const td = document.createElement("td");
                const text = document.createElement("div");
                text.textContent = game.board[row * game.size + col];
                if (text.textContent === "Qu") text.classList.add("qu");
                if ([
                    "M",
                    "W",
                    "Z"
                ].includes(text.textContent)) text.classList.add("underline");
                text.classList.add(`rotate${90 * random.next(0, 4)}`);
                td.setAttribute("data-x", String(row));
                td.setAttribute("data-y", String(col));
                td.appendChild(text);
                const div = document.createElement("div");
                div.classList.add("target");
                div.setAttribute("data-x", String(row));
                div.setAttribute("data-y", String(col));
                td.appendChild(div);
                tr.appendChild(td);
                this.tds.add(td);
            }
            table.appendChild(tr);
        }
        let touched = new Set();
        const deselect = ()=>{
            for (const td of touched)td.classList.remove("selected");
        };
        const registerTouch = (e)=>{
            const touch = e.touches[0];
            const cell = document.elementFromPoint(touch.clientX, touch.clientY);
            if (cell?.matches(".target")) {
                const td = cell.parentNode;
                td.classList.add("selected");
                if (!touched.has(td)) {
                    touched.add(td);
                    this.word.value += td.textContent;
                }
            }
        };
        table.addEventListener("touchstart", (e)=>{
            this.clear();
            deselect();
            touched = new Set();
            registerTouch(e);
        });
        table.addEventListener("touchend", ()=>{
            deselect();
            this.play();
        });
        table.addEventListener("touchmove", registerTouch);
        content.appendChild(table);
        return content;
    }
    afterAttach() {
        (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).permaFocus(this.word);
    }
    detach(next) {
        if (![
            "Score",
            "Define"
        ].includes(next)) this.timer.stop();
        return this.container;
    }
    async refresh(data = {}) {
        (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).persist();
        await (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).detachView("Board", "Board");
        await (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).attachView("Board", data);
    }
    play() {
        const game = this.game;
        let w = (this.word.value || "").toUpperCase();
        if (!w.length) return;
        if ((0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SETTINGS.shortcuts === "Shortcuts" && (w.length < 3 || (0, $e46db5192eb49d53$export$4405dec33e6bc9e5).includes(w))) {
            w = `${this.last}${w}`;
            this.word.value = w;
        }
        const score = game.play(w);
        this.last = w;
        (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).persist();
        const hide = (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SETTINGS.display === "Hide";
        this.kept = true;
        if (!hide && score) {
            this.displayScore();
            this.defn.textContent = (0, $55dcb6b52fc85e3d$export$f36d6a7a5c09a23e)(w, (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).DICT);
        } else {
            const original = this.word.value || undefined;
            if (!hide && game.played[w] < 0) this.word.classList.add("error");
            this.word.classList.add("fade");
            this.word.addEventListener("animationend", ()=>this.clear(original), {
                once: true
            });
        }
    }
    displayScore() {
        const game = this.game;
        if ((0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SETTINGS.display === "Hide") {
            this.score.textContent = "?";
            this.full.classList.add("hidden");
            return;
        }
        if ((0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SETTINGS.display === "Full") {
            const state = game.state();
            const p = state.progress;
            const details = `(${p.score}) ${Object.keys(p.suffixes).length}/${p.subwords}/${p.anagrams}`;
            const score = game.score.regular + game.score.overtime;
            const goal = state.totals[(0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SETTINGS.grade.toLowerCase()];
            const pct = Math.round(score / goal * 100).toFixed(0);
            this.full.classList.remove("hidden");
            this.full.textContent = `${details} - ${score}/${goal} (${pct}%)`;
        } else this.full.classList.add("hidden");
        const s = game.score;
        this.score.textContent = s.overtime ? `${s.regular}\xA0/\xA0${s.overtime}` : `${s.regular}`;
    }
    clear(w) {
        if (w && w !== this.word.value) return;
        this.word.value = "";
        this.word.classList.remove("error");
        this.word.classList.remove("fade");
        this.defn.textContent = "";
        this.kept = false;
    }
    createTimer(json) {
        const display = (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).createElementWithId("div", "timer");
        display.addEventListener("click", ()=>{
            this.timer.toggle();
            this.paused = !this.paused;
        });
        const duration = json ? json.duration : $5733c26233441270$var$DURATION;
        const elapsed = json ? json.elapsed : 0;
        const expire = ()=>{
            if (this.game && !this.game.expired) this.game.expired = +new Date();
        };
        const timer = new (0, $c97362ee32723b49$export$c57e9b2d8b9e4de)(display, duration, elapsed, expire, ()=>(0, $635ad17e88fce26c$export$4b08aed5f1ec6952).persist());
        return {
            display: display,
            timer: timer
        };
    }
    updateGames() {
        if (!(0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).GAMES) return;
        const game = this.game;
        const played = new Set();
        for(const w in game.played)if (game.played[w] > 0) played.add(w);
        if (!played.size) return;
        if ((0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).GAMES.length >= (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).LIMIT) (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).GAMES.shift();
        (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).GAMES.push([
            game.possible,
            played
        ]);
    }
    onLongPress() {
        const game = this.game;
        const size = game.size;
        const weights = [];
        for(let row = 0; row < size; row++){
            const a = [];
            for(let col = 0; col < size; col++)a.push(0);
            weights.push(a);
        }
        let total = 0;
        for(const word in game.possible){
            if (game.played[word]) continue;
            const score = (0, $e46db5192eb49d53$export$985739bfa5723e08).score(word);
            total += score;
            for (const p of game.possible[word])weights[p[1]][p[0]] += score;
        }
        for (const td of this.tds){
            const w = weights[Number(td.dataset.x)][Number(td.dataset.y)] / total;
            td.style.backgroundColor = `rgba(255,0,0,${w})`;
        }
    }
    onLongPressUp() {
        for (const td of this.tds)td.style.removeProperty("background-color");
    }
    onBeforeInput(e) {
        if (e.inputType.startsWith("delete") || e.data && $5733c26233441270$var$VALID(e.data)) return;
        e.preventDefault();
        const enter = [
            "insertLineBreak",
            "insertParagraph"
        ].includes(e.inputType);
        if (enter || e.data?.includes(" ")) this.play();
    }
    // TODO: up and down arrow to go through history
    async onKeyDown(e) {
        if (!this.word) return; // not attached
        if (this.kept) this.clear();
        const key = e.keyCode;
        if (key === 13 || key === 32) {
            e.preventDefault();
            this.play();
        } else if (!this.word.value && (key === 37 || key === 39)) e.preventDefault();
        else if (![
            0,
            37,
            39,
            8,
            46
        ].includes(key) && !$5733c26233441270$var$VALID(String.fromCharCode(key))) e.preventDefault();
    }
}





const $29f72165be3278d3$var$VALID = (s)=>s.split("").every((c)=>c >= "A" && c <= "Z" || c >= "a" && c <= "z");
class $29f72165be3278d3$export$4598af383c6b3a19 {
    constructor(json){
        this.defn = null;
        this.stats = null;
        this.anagrams = null;
        this.word = json ? json.word : "";
    }
    toJSON() {
        return {
            word: this.word
        };
    }
    async attach(word) {
        await Promise.all([
            (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).LOADED.DICT,
            (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).LOADED.STATS()
        ]);
        if (word) this.word = word;
        this.define = (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).createElementWithId("div", "define");
        this.search = (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).createElementWithId("input", "search");
        this.search.setAttribute("type", "text");
        this.search.classList.add("word");
        this.search.value = this.word;
        this.search.addEventListener("beforeinput", (e)=>this.onBeforeInput(e));
        this.search.addEventListener("input", ()=>{
            const w = this.search.value;
            this.query(w && $29f72165be3278d3$var$VALID(w) ? w : "");
        });
        this.define.appendChild(this.search);
        this.update();
        return this.define;
    }
    afterAttach() {
        (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).permaFocus(this.search);
    }
    query(w) {
        this.search.value = w;
        this.word = w.toUpperCase();
        this.update();
        (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).persist();
    }
    detach() {
        this.defn = null;
        this.stats = null;
        this.anagrams = null;
        return this.define;
    }
    update() {
        const val = (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).DICT[this.word];
        if (val) {
            const defn = (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).createElementWithId("div", "defineDefn");
            defn.classList.add("definition");
            defn.textContent = (0, $55dcb6b52fc85e3d$export$f36d6a7a5c09a23e)(this.word, (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).DICT);
            const hard = val.dict && !val.dict.includes((0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SETTINGS.dict.charAt(0)) || this.word.length < (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SETTINGS.min;
            if (hard) this.define.classList.add("hard");
            else this.define.classList.remove("hard");
            const addCells = (tr, label, data)=>{
                let td = document.createElement("td");
                const b = document.createElement("b");
                b.textContent = label;
                td.appendChild(b);
                tr.appendChild(td);
                td = document.createElement("td");
                td.classList.add("value");
                td.textContent = data;
                tr.appendChild(td);
            };
            const s = (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).STATS.stats(this.word, (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SETTINGS.dice, (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SETTINGS.dict);
            const stats = document.createElement("table");
            stats.classList.add("roundedTable");
            let tr = document.createElement("tr");
            addCells(tr, "Grade", s.grade === " " ? "S" : s.grade);
            addCells(tr, "Score", s.word ? String(s.word.p) : "-");
            stats.appendChild(tr);
            tr = document.createElement("tr");
            addCells(tr, "Frequency", s.freq ? String(s.freq) : "-");
            addCells(tr, "Anagram", s.anagram ? String(s.anagram.p) : "-");
            stats.appendChild(tr);
            stats.appendChild(tr);
            if (this.defn) this.define.removeChild(this.defn);
            this.define.appendChild(defn);
            this.defn = defn;
            if (this.stats) this.define.removeChild(this.stats);
            this.define.appendChild(stats);
            this.stats = stats;
        } else {
            if (this.defn) {
                this.define.removeChild(this.defn);
                this.defn = null;
            }
            if (this.stats) {
                this.define.removeChild(this.stats);
                this.stats = null;
            }
        }
        const anagrams = this.renderAnagrams();
        if (this.anagrams) this.define.removeChild(this.anagrams);
        this.define.appendChild(anagrams);
        this.anagrams = anagrams;
    }
    renderAnagrams() {
        const div = (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).createElementWithId("div", "defineAnagrams");
        const words = (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).STATS.anagrams(this.word, (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SETTINGS.dict).words;
        if (words.length <= 1) return div;
        const solo = [];
        const anadromes = new Set();
        for (const w of words){
            const r = w.split("").reverse().join("");
            if (r !== w && words.includes(r)) anadromes.add(`${[
                w,
                r
            ].sort().join(" ")}`);
            else solo.push(w);
        }
        const format = (w)=>{
            const e = document.createElement(w === this.word ? "b" : "span");
            e.textContent = w;
            e.addEventListener("click", ()=>this.query(w));
            return e;
        };
        for (const pair of anadromes){
            const [a, b] = pair.split(" ");
            div.appendChild(document.createTextNode(" ("));
            div.appendChild(format(a));
            div.appendChild(document.createTextNode(" "));
            div.appendChild(format(b));
            div.appendChild(document.createTextNode(") "));
        }
        for (const w of solo){
            div.appendChild(format(w));
            div.appendChild(document.createTextNode(" "));
        }
        return div;
    }
    async onBeforeInput(e) {
        if (e.inputType.startsWith("delete") || e.data && $29f72165be3278d3$var$VALID(e.data)) return;
        e.preventDefault();
        const enter = [
            "insertLineBreak",
            "insertParagraph"
        ].includes(e.inputType);
        if (enter || e.data?.includes(" ")) {
            if (this.word) this.query("");
            else await (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).toggleView("Define");
        }
    }
    async onKeyDown(e) {
        if (!this.search) return; // not attached
        const key = e.keyCode;
        if (key === 13 || key === 32) {
            e.preventDefault();
            if (this.word) this.query("");
            else await (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).toggleView("Define");
        } else if (key === 27) await (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).toggleView("Define");
        else if (![
            0,
            37,
            39,
            8,
            46
        ].includes(key) && !$29f72165be3278d3$var$VALID(String.fromCharCode(key))) e.preventDefault();
    }
}




class $e7e585f6fffb4ff0$export$5fe8222595b01ed2 {
    toJSON() {}
    attach() {
        // NOTE: The '#menu' here would make more sense, but uBlock's "Web Annoyances Ultralist" has:
        // 'github.io###menu, .fixedHeaderContainer, .menu-btn:style(position: absolute !important;)'
        this.menu = (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).createElementWithId("div", "men");
        const title = (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).createElementWithId("h1", "title");
        title.textContent = "BOGGLE";
        title.addEventListener("long-press", async ()=>{
            const key = (await caches.keys()).find((n)=>n.includes(":cache:"));
            if (key) await caches.delete(key);
            document.location.reload(true);
        });
        this.menu.appendChild(title);
        const nav = document.createElement("nav");
        const createButton = (name, fn)=>{
            const button = document.createElement("button");
            button.classList.add("toggle");
            button.textContent = name;
            button.addEventListener("click", fn);
            return button;
        };
        if ((0, $635ad17e88fce26c$export$4b08aed5f1ec6952).Views.Board.game) {
            nav.appendChild(createButton("RESUME", ()=>(0, $635ad17e88fce26c$export$4b08aed5f1ec6952).toggleView("Board")));
            nav.appendChild(createButton("NEW GAME", ()=>(0, $635ad17e88fce26c$export$4b08aed5f1ec6952).toggleView("Board", {
                    new: true
                })));
        } else nav.appendChild(createButton("PLAY", ()=>(0, $635ad17e88fce26c$export$4b08aed5f1ec6952).toggleView("Board")));
        nav.appendChild(createButton("TRAIN", ()=>(0, $635ad17e88fce26c$export$4b08aed5f1ec6952).toggleView("Training")));
        nav.appendChild(createButton("DEFINE", ()=>(0, $635ad17e88fce26c$export$4b08aed5f1ec6952).toggleView("Define")));
        nav.appendChild(createButton("STATS", ()=>(0, $635ad17e88fce26c$export$4b08aed5f1ec6952).toggleView("Stats")));
        nav.appendChild(createButton("SETTINGS", ()=>(0, $635ad17e88fce26c$export$4b08aed5f1ec6952).toggleView("Settings")));
        this.menu.appendChild(nav);
        return this.menu;
    }
    detach() {
        return this.menu;
    }
}






class $d5af522aef81d25f$export$ce711eda3c29ab03 {
    constructor(training){
        this.training = training;
    }
    toJSON() {}
    async attach() {
        await this.training.init();
        this.review = (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).createElementWithId("div", "review");
        const back = (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).createBackButton(()=>(0, $635ad17e88fce26c$export$4b08aed5f1ec6952).toggleView("Training"));
        this.review.appendChild((0, $635ad17e88fce26c$export$4b08aed5f1ec6952).createTopbar(back, null, this.training.progress));
        const d = (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SETTINGS.dice.charAt(0).toLowerCase();
        const score = (k)=>(0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).STATS.anagrams(k, (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SETTINGS.dict)[d] || 0;
        const store = new (0, $565bb8264fce4bd8$export$390f32400eaf98c9)("training", (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SETTINGS.dict);
        const data = await store.get("data") || [];
        const keys = data.filter((w)=>!w.c || w.e < 2.0).sort((a, b)=>score(b.k) / b.e - score(a.k) / a.e).map((w)=>w.k);
        const wrapper = (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).createElementWithId("div", "review-results-wrapper");
        if (!keys.length) wrapper.appendChild((0, $635ad17e88fce26c$export$4b08aed5f1ec6952).createPlaceholder());
        else for (const k of keys){
            const table = (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).createElementWithId("table", "review-results");
            (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).addAnagramRows(table, (0, $55dcb6b52fc85e3d$export$aaaeab0fac9a3ccb)((0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).STATS.anagrams(k, (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SETTINGS.dict).words));
            wrapper.appendChild(table);
        }
        this.review.appendChild(wrapper);
        return this.review;
    }
    detach() {
        return this.review;
    }
}





class $3ffa33bc3d9c668d$export$b5fd6146180b74ff {
    constructor(board){
        this.board = board;
    }
    toJSON() {}
    async attach() {
        await this.board.init();
        this.container = (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).createElementWithId("div", "game");
        // TODO: wrapper should really be container, not game
        const wrapper = (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).createElementWithId("div", "score-history");
        const back = (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).createBackButton(()=>(0, $635ad17e88fce26c$export$4b08aed5f1ec6952).toggleView("Board"));
        this.container.appendChild((0, $635ad17e88fce26c$export$4b08aed5f1ec6952).createTopbar(back, this.board.timerDisplay, this.board.score));
        const game = this.board.game;
        const state = game.state();
        const score = game.score.regular + game.score.overtime;
        const goal = state.totals[(0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SETTINGS.grade.toLowerCase()];
        const details = `${score}/${goal} (${Math.round(score / goal * 100).toFixed(0)}%)`;
        const current = $3ffa33bc3d9c668d$var$makeCollapsible(game.id, details, "block");
        const div = document.createElement("div");
        div.classList.add("collapsible-content");
        this.displayPlayed(state, div, true);
        this.displayPossible(state, div);
        wrapper.appendChild(current);
        wrapper.appendChild(div);
        // Start off with played expanded
        current.classList.add("active");
        div.style.display = "block";
        for(let i = (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).HISTORY.length - 1; i >= 0; i--){
            const state = (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).HISTORY[i];
            let score = 0;
            for (const [w, t] of Object.entries(state.words))if (t > 0) score += (0, $e46db5192eb49d53$export$985739bfa5723e08).score(w);
            if (!score) continue;
            const details = `${score}/${state.goal[(0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SETTINGS.grade]} (${Math.round(score / state.goal[(0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SETTINGS.grade] * 100).toFixed(0)}%)`;
            const div = document.createElement("div");
            div.classList.add("collapsible-content");
            div.classList.add("lazy");
            const button = $3ffa33bc3d9c668d$var$makeCollapsible(state.seed, details, "block", ()=>{
                if (div.classList.contains("lazy")) {
                    div.classList.remove("lazy");
                    const game = (0, $e46db5192eb49d53$export$985739bfa5723e08).fromJSON(state, (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).TRIE, (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).DICT, (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).STATS);
                    const s = game.state();
                    this.displayPlayed(s, div);
                    this.displayPossible(s, div);
                }
            });
            wrapper.appendChild(button);
            wrapper.appendChild(div);
        }
        this.container.appendChild(wrapper);
        return this.container;
    }
    detach() {
        return this.container;
    }
    displayPlayed(state, div, expanded = false) {
        const p = state.progress;
        const details = `(${p.score}) ${Object.keys(p.suffixes).length}/${p.subwords}/${p.anagrams} (${p.invalid}/${p.total})`;
        const button = $3ffa33bc3d9c668d$var$makeCollapsible("PLAYED", details, "table");
        const table = document.createElement("table");
        table.classList.add("collapsible-content");
        table.classList.add("results");
        table.classList.add("played");
        for (const { word: word, grade: grade, overtime: overtime, defn: defn, invalid: invalid } of state.played){
            const tr = document.createElement("tr");
            if (!invalid && grade < (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SETTINGS.grade) tr.classList.add("hard");
            if (invalid) tr.classList.add("error");
            if (overtime) tr.classList.add("overtime");
            let td = document.createElement("td");
            const b = document.createElement("b");
            b.textContent = word;
            td.appendChild(b);
            tr.appendChild(td);
            td = document.createElement("td");
            if (defn) td.textContent = defn;
            tr.appendChild(td);
            table.appendChild(tr);
        }
        if (expanded) {
            button.classList.add("active");
            table.style.display = "table";
        }
        div.appendChild(button);
        div.appendChild(table);
    }
    displayPossible(state, div, expanded = false) {
        const tot = state.totals;
        const details = `${tot.d}/${tot.c}/${tot.b}/${tot.a} (${tot.s})`;
        const button = $3ffa33bc3d9c668d$var$makeCollapsible("POSSIBLE", details, "table");
        const table = document.createElement("table");
        table.classList.add("collapsible-content");
        table.classList.add("results");
        table.classList.add("possible");
        for (const { word: word, grade: grade, root: root, missing: missing, defn: defn } of state.remaining){
            const tr = document.createElement("tr");
            if (grade < (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SETTINGS.grade) tr.classList.add("hard");
            let td = document.createElement("td");
            const b = document.createElement("b");
            if (root) {
                const rootSpan = document.createElement("span");
                rootSpan.textContent = root;
                const suffixSpan = document.createElement("span");
                suffixSpan.classList.add("underline");
                suffixSpan.textContent = word.slice(root.length);
                b.appendChild(rootSpan);
                b.appendChild(suffixSpan);
            } else {
                if (missing) b.classList.add("underline");
                b.textContent = word;
            }
            td.appendChild(b);
            tr.appendChild(td);
            td = document.createElement("td");
            td.textContent = defn;
            tr.appendChild(td);
            table.appendChild(tr);
        }
        if (expanded) {
            button.classList.add("active");
            table.style.display = "table";
        }
        div.appendChild(button);
        div.appendChild(table);
    }
}
function $3ffa33bc3d9c668d$var$makeCollapsible(title, details, display, fn) {
    const button = document.createElement("button");
    button.setAttribute("type", "button");
    button.classList.add("collapsible");
    const div = document.createElement("div");
    const titleSpan = document.createElement("span");
    titleSpan.classList.add("collapsible-title");
    titleSpan.textContent = title;
    const detailsSpan = document.createElement("span");
    detailsSpan.classList.add("collapsible-details");
    detailsSpan.textContent = details;
    div.appendChild(titleSpan);
    div.appendChild(detailsSpan);
    button.appendChild(div);
    button.addEventListener("click", ()=>{
        button.classList.toggle("active");
        const content = button.nextElementSibling;
        if (content.style.display === display) content.style.display = "none";
        else {
            if (fn) fn();
            content.style.display = display;
        }
    });
    return button;
}





const $952a3e9600c33f15$var$CHARS = new Set([
    "B",
    "b",
    "N",
    "n",
    "E",
    "e",
    "C",
    "c",
    "O",
    "o",
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9"
]);
const $952a3e9600c33f15$var$VALID = (s)=>s.split("").every((c)=>$952a3e9600c33f15$var$CHARS.has(c));
class $952a3e9600c33f15$export$7d05e0deed78c249 {
    toJSON() {}
    attach() {
        this.settings = (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).createElementWithId("div", "settings");
        this.seed = (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).createElementWithId("input", "seed");
        this.seed.setAttribute("type", "text");
        this.seed.value = (0, $e46db5192eb49d53$export$985739bfa5723e08).encodeID((0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SETTINGS, (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SEED);
        this.seed.addEventListener("input", ()=>this.onInput(this.seed.value || ""));
        this.seed.addEventListener("beforeinput", (e)=>this.onBeforeInput(e));
        const back = (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).createBackButton(()=>(0, $635ad17e88fce26c$export$4b08aed5f1ec6952).toggleView("Menu"));
        this.settings.appendChild((0, $635ad17e88fce26c$export$4b08aed5f1ec6952).createTopbar(back, this.seed, null));
        const checkedRadioRow = (k, opts, fn, id)=>{
            const row = document.createElement("div");
            row.classList.add("row");
            const radios = (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).createRadios(id || k, opts.map((s)=>s === String((0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SETTINGS[k]) ? [
                    s
                ] : s), fn);
            row.appendChild(radios);
            return row;
        };
        this.settings.appendChild(checkedRadioRow("dice", [
            "New",
            "Old",
            "Big"
        ], function() {
            const min = this.value === "Big" ? 4 : 3;
            document.getElementById(`min${min}`).checked = true;
            (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).updateSettings({
                dice: this.value,
                min: min
            });
        }));
        this.settings.appendChild(checkedRadioRow("min", [
            "3",
            "4",
            "5"
        ], function() {
            (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).updateSettings({
                min: Number(this.value)
            });
        }));
        this.settings.appendChild(checkedRadioRow("dict", [
            "NWL",
            "ENABLE",
            "CSW"
        ], function() {
            (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).updateSettings({
                dict: this.value
            });
        }));
        this.settings.appendChild(checkedRadioRow("grade", [
            "A",
            "B",
            "C",
            "D"
        ], function() {
            (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).updateSettings({
                grade: this.value
            });
        }));
        this.settings.appendChild(checkedRadioRow("display", [
            "Hide",
            "Show",
            "Full"
        ], function() {
            (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).updateSettings({
                display: this.value
            });
        }, "scoreDisplay"));
        this.settings.appendChild(checkedRadioRow("shortcuts", [
            "Shortcuts",
            "None"
        ], function() {
            (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).updateSettings({
                shortcuts: this.value
            });
        }));
        this.settings.appendChild(checkedRadioRow("theme", [
            "System",
            "Light",
            "Dark"
        ], function() {
            const theme = this.value;
            (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).updateSettings({
                theme: theme
            });
            (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).setTheme(theme);
        }));
        return this.settings;
    }
    detach() {
        return this.settings;
    }
    update() {
        this.seed.textContent = (0, $e46db5192eb49d53$export$985739bfa5723e08).encodeID((0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SETTINGS, (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SEED);
        this.seed.classList.remove("error");
        const set = (id)=>document.getElementById(id).checked = true;
        set(`dice${(0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SETTINGS.dice}`);
        set(`min${(0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SETTINGS.min}`);
        set(`dict${(0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SETTINGS.dict}`);
        set(`grade${(0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SETTINGS.grade}`);
        set(`scoreDisplay${(0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SETTINGS.display}`);
        set(`shortcuts${(0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SETTINGS.shortcuts}`);
        set(`theme${(0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SETTINGS.theme}`);
    }
    onInput(id) {
        if (!$952a3e9600c33f15$var$VALID(id)) return;
        const [settings, seed] = (0, $e46db5192eb49d53$export$985739bfa5723e08).decodeID(id);
        if (!(0, $635ad17e88fce26c$export$4b08aed5f1ec6952).valid(settings, seed)) this.seed.classList.add("error");
        else {
            (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).updateSettings(settings, seed, false);
            this.update();
        }
    }
    onBeforeInput(e) {
        if (e.inputType.startsWith("delete") || e.data && $952a3e9600c33f15$var$VALID(e.data)) return;
        e.preventDefault();
    }
    async onKeyDown(e) {
        if (!this.seed) return; // not attached
        const key = e.keyCode;
        if ([
            0,
            37,
            39,
            8,
            46
        ].includes(key) || $952a3e9600c33f15$var$VALID(String.fromCharCode(key))) return;
        e.preventDefault();
    }
}




class $9bc8b3c506b9c499$export$1e3e8ecfe0e6273a {
    constructor(json){
        this.table = null;
        this.section = json ? json.section : "WORD";
    }
    toJSON() {
        return {
            section: this.section
        };
    }
    // TODO: why is there no spinner?
    async attach() {
        await (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).LOADED.GAMES();
        // TODO: cache this, invalidate if GAMES/dice/dict/min changes?
        const data = (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).STATS.history((0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).GAMES, (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SETTINGS.dice, (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SETTINGS.dict);
        this.stats = (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).createElementWithId("div", "stats");
        const back = (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).createBackButton(()=>(0, $635ad17e88fce26c$export$4b08aed5f1ec6952).toggleView("Menu"));
        const display = (s)=>this.display(s, data);
        const radios = (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).createRadios("statsSelect", [
            "WORD",
            "ANAGRAM",
            "PAIR"
        ].map((s)=>s === this.section ? [
                s
            ] : s), function() {
            display(this.value);
            (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).persist();
        });
        this.stats.appendChild((0, $635ad17e88fce26c$export$4b08aed5f1ec6952).createTopbar(back, radios, null));
        this.display(this.section, data);
        return this.stats;
    }
    detach() {
        this.table = null;
        return this.stats;
    }
    display(section, data) {
        this.section = section;
        const { words: words, anadromes: anadromes, anagrams: anagrams } = data;
        const link = (w)=>{
            const b = document.createElement("b");
            b.textContent = w;
            b.addEventListener("click", ()=>(0, $635ad17e88fce26c$export$4b08aed5f1ec6952).toggleView("Define", w));
            return b;
        };
        let table = document.createElement("table");
        table.classList.add("roundedTable");
        if (section === "PAIR") {
            if (!anadromes.length) table = (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).createPlaceholder();
            else for (const { n: n, fn: fn, d: d, fd: fd, e: e } of anadromes){
                const tr = document.createElement("tr");
                let td = document.createElement("td");
                td.appendChild(link(n));
                tr.appendChild(td);
                td = document.createElement("td");
                td.textContent = `${fn}/${fd} (${e})`;
                tr.appendChild(td);
                td = document.createElement("td");
                td.appendChild(link(d));
                tr.appendChild(td);
                table.appendChild(tr);
            }
        } else if (section === "WORD") {
            if (!words.length) table = (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).createPlaceholder();
            else for (const { w: w, found: found, all: all } of words){
                const tr = document.createElement("tr");
                let td = document.createElement("td");
                td.appendChild(link(w));
                tr.appendChild(td);
                td = document.createElement("td");
                td.textContent = `${found}/${all}`;
                tr.appendChild(td);
                table.appendChild(tr);
            }
        } else {
            if (!anagrams.length) table = (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).createPlaceholder();
            else for (const group of anagrams){
                const tr = document.createElement("tr");
                const td = document.createElement("td");
                let together = [];
                let wait = false;
                for (const { raw: raw, found: found, all: all } of group){
                    const w = raw.replace(/[^A-Z]/, "");
                    if (raw.startsWith("(")) {
                        const b = document.createElement("b");
                        b.textContent = "(";
                        together.push(b);
                        wait = true;
                    }
                    together.push(link(w));
                    const span = document.createElement("span");
                    span.textContent = ` ${found}/${all}`;
                    if (raw.endsWith(")")) {
                        together.push(span);
                        const b = document.createElement("b");
                        b.textContent = ")";
                        together.push(b);
                        wait = false;
                    } else {
                        if (wait) span.textContent += " ";
                        together.push(span);
                    }
                    if (!wait) {
                        for (const e of together)td.appendChild(e);
                        td.appendChild(document.createElement("br"));
                        together = [];
                    }
                }
                tr.appendChild(td);
                table.appendChild(tr);
            }
        }
        if (this.table) this.stats.removeChild(this.table);
        this.stats.appendChild(table);
        this.table = table;
    }
}






const $7425debbed8aea0b$var$INTERVAL = 1000;
class $7425debbed8aea0b$export$9e19812ff71b0df9 {
    toJSON() {}
    async init() {
        await Promise.all([
            (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).LOADED.TRAINING,
            (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).LOADED.DICT,
            (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).LOADED.STATS()
        ]);
        if (!this.pool || this.pool.type !== (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SETTINGS.dict) {
            const store = new (0, $565bb8264fce4bd8$export$390f32400eaf98c9)("training", (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SETTINGS.dict);
            this.pool = await (0, $96aac1339b3e6cb8$export$c612839cda33ff7e).create((0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).STATS, (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SETTINGS.dice, (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SETTINGS.dict, store, (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SETTINGS.min);
        }
        if (!this.progress) {
            this.progress = (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).createElementWithId("div", "progress");
            this.updateProgress();
            this.interval = setInterval(()=>this.updateProgress(), $7425debbed8aea0b$var$INTERVAL);
        }
    }
    async attach() {
        await this.init();
        this.train = (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).createElementWithId("div", "train");
        this.next();
        return this.train;
    }
    async detach() {
        if (this.restore) this.restore();
        if (this.interval) clearInterval(this.interval);
        this.content = null;
        return this.train;
    }
    next() {
        const content = (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).createElementWithId("div", "content");
        const { label: label, group: group, update: update, restore: restore } = this.pool.next();
        this.restore = restore;
        const trainWord = document.createElement("div");
        trainWord.classList.add("word");
        trainWord.textContent = label;
        const sizeHint = (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).createElementWithId("div", "sizeHint");
        sizeHint.style.visibility = "hidden";
        sizeHint.textContent = String(group.length);
        const rating = this.createRatingToggles(update);
        const table = document.createElement("table");
        table.classList.add("results", "hidden");
        (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).addAnagramRows(table, group);
        const progress = (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).createElementWithId("div", "progress-wrapper");
        progress.appendChild(this.progress);
        progress.addEventListener("mouseup", ()=>(0, $635ad17e88fce26c$export$4b08aed5f1ec6952).toggleView("Review"));
        progress.addEventListener("long-press", ()=>{
            if (!rating.classList.contains("hidden")) return;
            sizeHint.style.visibility = "visible";
        });
        progress.addEventListener("long-press-up", ()=>{
            sizeHint.style.visibility = "hidden";
        });
        const back = (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).createBackButton(()=>(0, $635ad17e88fce26c$export$4b08aed5f1ec6952).toggleView("Menu"));
        content.appendChild((0, $635ad17e88fce26c$export$4b08aed5f1ec6952).createTopbar(back, null, progress));
        const wrapper = document.createElement("div");
        wrapper.classList.add("wrapper");
        wrapper.appendChild(trainWord);
        wrapper.appendChild(table);
        content.appendChild(wrapper);
        content.appendChild(sizeHint);
        const rwrapper = (0, $635ad17e88fce26c$export$4b08aed5f1ec6952).createElementWithId("div", "rating-wrapper");
        rwrapper.appendChild(rating);
        content.appendChild(rwrapper);
        const listener = (e)=>{
            if (![
                back,
                progress,
                this.progress
            ].includes(e.target)) {
                content.removeEventListener("click", listener);
                trainWord.classList.add("hidden");
                sizeHint.classList.add("hidden");
                table.classList.remove("hidden");
                rating.classList.remove("hidden");
            }
        };
        content.addEventListener("click", listener);
        if (this.content) this.train.removeChild(this.content);
        this.train.appendChild(content);
        this.content = content;
    }
    createRatingToggles(update) {
        const toggles = document.createElement("div");
        toggles.setAttribute("id", "rating");
        toggles.classList.add("toggle-group");
        toggles.classList.add("horizontal");
        toggles.classList.add("hidden");
        for(let i = 0; i < 6; i++){
            const toggle = document.createElement("button");
            toggle.setAttribute("id", `rating${i}`);
            toggle.setAttribute("type", "button");
            toggle.classList.add("toggle");
            toggle.textContent = String(i);
            toggles.appendChild(toggle);
            toggle.addEventListener("click", async ()=>{
                await update(Number(toggle.textContent));
                // Update progress before its scheduled interval to ensure there's no perceived lag
                this.updateProgress();
                this.restore = null;
                this.next();
            });
        }
        return toggles;
    }
    updateProgress() {
        this.progress.textContent = `${this.pool.overdue()}\xA0/\xA0${this.pool.size}`;
    }
    constructor(){
        this.content = null;
        this.restore = null;
        this.interval = null;
    }
}


class $635ad17e88fce26c$var$Loader {
    attach() {
        this.loader = $635ad17e88fce26c$export$4b08aed5f1ec6952.createElementWithId("div", "loader");
        const spinner = $635ad17e88fce26c$export$4b08aed5f1ec6952.createElementWithId("div", "spinner");
        this.loader.appendChild(spinner);
        return this.loader;
    }
    detach() {
        return this.loader;
    }
}
const $635ad17e88fce26c$export$4b08aed5f1ec6952 = new class {
    async create() {
        setTimeout(()=>window.scrollTo(0, 1), 0);
        const mobile = typeof window.orientation !== "undefined" || navigator.userAgent.includes("IEMobile");
        if (mobile) {
            setTimeout(()=>{
                const meta = document.querySelector("meta[name=viewport]");
                const w = window.innerWidth;
                const h = window.innerHeight;
                meta.setAttribute("content", `width=${w}, height=${h}, initial-scale=1, user-scalable=no, minimal-ui`);
            }, 200);
            // https://stackoverflow.com/questions/7919172
            window.addEventListener("orientationchange", ()=>{
                document.body.style.display = "none";
                // eslint-disable-next-line no-unused-expressions
                document.body.offsetHeight; // cause a reflow
                document.body.style.display = "block"; // cause a repaint
            });
        }
        const pref = window.matchMedia("(prefers-color-scheme: dark)");
        const listener = (e)=>{
            if ((0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SETTINGS.theme === "System") this.setTheme(e.matches ? "Dark" : "Light");
        };
        try {
            pref.addEventListener("change", listener);
        } catch (err) {
            pref.addListener(listener);
        }
        this.setTheme((0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SETTINGS.theme === "System" ? pref.matches ? "Dark" : "Light" : (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SETTINGS.theme);
        this.root = document.getElementById("display");
        const state = JSON.parse(localStorage.getItem("state"));
        this.current = state && state.current !== "Define" ? state.current : "Menu";
        this.previous = state && state.previous !== "Define" ? state.previous : "Menu";
        this.loader = new $635ad17e88fce26c$var$Loader();
        const VIEWS = {
            Menu: (0, $e7e585f6fffb4ff0$export$5fe8222595b01ed2),
            Board: (0, $5733c26233441270$export$373e09b633948dc),
            Training: (0, $7425debbed8aea0b$export$9e19812ff71b0df9),
            Define: (0, $29f72165be3278d3$export$4598af383c6b3a19),
            Stats: (0, $9bc8b3c506b9c499$export$1e3e8ecfe0e6273a),
            Settings: (0, $952a3e9600c33f15$export$7d05e0deed78c249)
        };
        const views = state ? state.views : {};
        this.Views = {};
        for (const [type, V] of Object.entries(VIEWS))// @ts-ignore
        this.Views[type] = new V(views[type]);
        this.Views.Review = new (0, $d5af522aef81d25f$export$ce711eda3c29ab03)(this.Views.Training);
        this.Views.Score = new (0, $3ffa33bc3d9c668d$export$b5fd6146180b74ff)(this.Views.Board);
        await this.setup();
        this.BACK = document.createElement("img");
        this.BACK.src = document.getElementById("svg").src;
        this.BACK.height = 20;
        document.addEventListener("keydown", (e)=>this.onKeyDown(e));
        document.addEventListener("swiped-left", ()=>this.toggleView("Define"));
        document.addEventListener("swiped-right", ()=>this.toggleView("Define"));
        window.addEventListener("hashchange", ()=>this.onHashChange());
        window.addEventListener("beforeunload", ()=>this.persist());
        await this.attachView(this.current);
    }
    persist(previous = false) {
        const state = JSON.parse(localStorage.getItem("state")) || {};
        state.current = this.current;
        state.previous = this.previous;
        state.views = state.views || {};
        state.views[this.current] = this.Views[this.current];
        if (previous) state.views[this.previous] = this.Views[this.previous];
        localStorage.setItem("state", JSON.stringify(state));
    }
    async attachView(view, data) {
        // console.log(+new Date(), 'ATTACHING', view, data, this.Views[view]);
        this.root.appendChild(this.loader.attach());
        const v = this.Views[view];
        const attached = await v.attach(data);
        this.root.removeChild(this.loader.detach());
        this.root.appendChild(attached);
        if (v.afterAttach) v.afterAttach();
    // console.log(+new Date(), 'ATTACHED', view, data, this.Views[view]);
    }
    async detachView(view, next) {
        // console.log(+new Date(), 'DETACHING', view, this.Views[view]);
        this.root.removeChild(await this.Views[view].detach(next));
    // console.log(+new Date(), 'DETACHED', view, this.Views[view]);
    }
    async toggleView(view, data) {
        // console.log('TOGGLE', view, {current: this.current, previous: this.previous});
        if (this.current === view) {
            await this.detachView(view, this.previous);
            this.current = this.previous;
            this.previous = view;
            await this.attachView(this.current, data);
        } else {
            await this.detachView(this.current, view);
            this.previous = this.current;
            this.current = view;
            await this.attachView(view, data);
        }
        this.persist(true);
    }
    async setup() {
        const setupFromHistory = async ()=>{
            await (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).LOADED.HISTORY;
            if ((0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).HISTORY.length) {
                const id = (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).HISTORY[(0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).HISTORY.length - 1].seed;
                const [settings] = (0, $e46db5192eb49d53$export$985739bfa5723e08).decodeID(id);
                const rand = new (0, $69e3cfcc1b264755$export$a92776769f460054)();
                rand.seed = (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SEED;
                rand.next();
                this.updateSettings(settings, rand.seed % (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).MAX_SEED, false);
            }
        };
        const hash = document.location.hash?.slice(1);
        if (!hash) {
            const existing = this.Views.Board.game;
            if (existing) {
                const [settings, seed] = (0, $e46db5192eb49d53$export$985739bfa5723e08).decodeID(existing.seed);
                this.updateSettings(settings, seed, false);
            } else return setupFromHistory();
        } else {
            const [settings, seed] = (0, $e46db5192eb49d53$export$985739bfa5723e08).decodeID(hash);
            if (!this.valid(settings, seed)) return setupFromHistory();
            this.updateSettings(settings, seed, false);
        }
    }
    async onKeyDown(e) {
        const key = e.keyCode;
        const currentView = this.Views[this.current];
        if (key === 191 && e.shiftKey) {
            e.preventDefault();
            await this.toggleView("Define");
        } else if ("onKeyDown" in currentView) await currentView.onKeyDown(e);
    }
    async onHashChange() {
        if (!document.location.hash) return;
        const [settings, seed] = (0, $e46db5192eb49d53$export$985739bfa5723e08).decodeID(document.location.hash.slice(1));
        if (!this.valid(settings, seed)) return;
        let refresh = seed !== (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SEED;
        if (!refresh) {
            const s = {
                ...(0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SETTINGS
            };
            refresh = s.dice !== settings.dice || s.min !== settings.min || s.dict !== settings.dict;
        }
        this.updateSettings(settings, seed, false);
        if (this.current === "Settings") this.Views[this.current].update();
        else if (refresh && [
            "Board",
            "Score"
        ].includes(this.current)) return this.Views.Board.refresh({
            new: true,
            allowDupes: true
        });
    }
    valid(settings, seed) {
        return !!(!isNaN(seed) && Number.isInteger(seed) && seed < (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).MAX_SEED && settings.dice && settings.dict && settings.min);
    }
    updateSettings(settings, seed, dom = true) {
        Object.assign((0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SETTINGS, settings);
        localStorage.setItem("settings", JSON.stringify((0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SETTINGS));
        if (typeof seed === "number") (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SEED = seed;
        const id = (0, $e46db5192eb49d53$export$985739bfa5723e08).encodeID((0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SETTINGS, (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SEED);
        window.history.replaceState(null, "", `#${id}`);
        if (dom && this.current === "Settings") {
            const view = this.Views[this.current];
            view.seed.textContent = id;
            view.seed.classList.remove("error");
        }
    }
    createElementWithId(type, id) {
        const element = document.createElement(type);
        element.setAttribute("id", id);
        return element;
    }
    createTopbar(left, center, right) {
        const topbar = this.createElementWithId("header", "topbar");
        topbar.appendChild(left || document.createElement("div"));
        topbar.appendChild(center || document.createElement("div"));
        topbar.appendChild(right || document.createElement("div"));
        return topbar;
    }
    createBackButton(fn) {
        const back = this.createElementWithId("div", "back");
        back.appendChild(this.BACK);
        back.addEventListener("mouseup", fn);
        return back;
    }
    createPlaceholder() {
        const empty = this.createElementWithId("div", "empty");
        empty.textContent = "...";
        return empty;
    }
    permaFocus(element) {
        element.addEventListener("blur", ()=>setTimeout(()=>element.focus(), 20));
        element.focus();
    }
    setTheme(theme) {
        document.documentElement.setAttribute("data-theme", theme.toLowerCase());
    }
    addAnagramRows(table, group) {
        for (const r of group){
            const w = r.replace(/[^A-Z]/, "");
            const tr = document.createElement("tr");
            const grade = (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).STATS.stats(w, (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SETTINGS.dice, (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SETTINGS.dict).grade;
            if (grade < (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SETTINGS.grade) tr.classList.add("hard");
            let td = document.createElement("td");
            const b = document.createElement("b");
            const s = r.startsWith("(") ? `${r}\xa0` : r.endsWith(")") ? `\xa0${r}` : `\xa0${r}\xa0`;
            b.textContent = `\xa0${s}\xa0`;
            td.appendChild(b);
            tr.appendChild(td);
            td = document.createElement("td");
            td.textContent = (0, $55dcb6b52fc85e3d$export$f36d6a7a5c09a23e)(w, (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).DICT);
            tr.appendChild(td);
            table.appendChild(tr);
        }
    }
    createRadios(id, values, listener) {
        const radios = this.createElementWithId("span", id);
        radios.classList.add("toggle-group");
        radios.classList.add("horizontal");
        radios.setAttribute("role", "radiogroup");
        for (let val of values){
            let checked = false;
            if (Array.isArray(val)) {
                checked = true;
                val = val[0];
            }
            const radio = this.createElementWithId("input", `${id}${val}`);
            radio.classList.add("hide");
            radio.setAttribute("type", "radio");
            radio.setAttribute("name", id);
            radio.setAttribute("value", val);
            if (checked) radio.setAttribute("checked", "checked");
            const label = document.createElement("label");
            label.classList.add("toggle");
            label.setAttribute("for", `${id}${val}`);
            label.textContent = val.toUpperCase();
            radio.addEventListener("click", listener.bind(radio));
            radios.appendChild(radio);
            radios.appendChild(label);
        }
        return radios;
    }
}();


const $ffaaba23bb5f0d08$export$153e5dc2c098b35c = new class {
    async backup() {
        const data = {
            history: await (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).STORE.get("history")
        };
        for (const type of [
            "NWL",
            "ENABLE",
            "CSW"
        ]){
            const store = new (0, $565bb8264fce4bd8$export$390f32400eaf98c9)("training", type);
            data[type] = await store.get("data");
        }
        data.settings = JSON.parse(localStorage.getItem("settings"));
        return JSON.stringify(data);
    }
    async restore(data) {
        await (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).STORE.set("history", data.history);
        for (const type of [
            "NWL",
            "ENABLE",
            "CSW"
        ]){
            const store = new (0, $565bb8264fce4bd8$export$390f32400eaf98c9)("training", type);
            await store.set("data", data[type]);
        }
        localStorage.setItem("settings", JSON.stringify(data.settings));
    }
    async modify(w, fn) {
        const store = new (0, $565bb8264fce4bd8$export$390f32400eaf98c9)("training", (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SETTINGS.dict);
        const pool = await (0, $96aac1339b3e6cb8$export$c612839cda33ff7e).create((0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).STATS, (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SETTINGS.dice, (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SETTINGS.dict, store, (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af).SETTINGS.min);
        const k = (0, $2f4d5440d89e6de9$export$3cdec2bba15e3523).toAnagram(w);
        let found;
        // @ts-ignore
        const learned = pool.learned;
        const popped = [];
        for(found = learned.pop(); found && found.k !== k; found = learned.pop())popped.push(found);
        if (!found) throw RangeError();
        learned.push(fn(found));
        for (const p of popped)learned.push(p);
        return store.set("data", learned.data);
    }
    get state() {
        return JSON.parse(localStorage.getItem("state"));
    }
}();
// @ts-ignore
window.global = (0, $c1afce2e0b574aed$export$90b4d2ff6acb88af);
// @ts-ignore
window.UI = (0, $635ad17e88fce26c$export$4b08aed5f1ec6952);
// @ts-ignore
window.Debug = $ffaaba23bb5f0d08$export$153e5dc2c098b35c;



// eslint-disable-next-line @typescript-eslint/no-floating-promises
(0, $635ad17e88fce26c$export$4b08aed5f1ec6952).create();


//# sourceMappingURL=index.a8a9dac6.js.map
